import type { FC } from "react";

import clsx from "clsx";

import * as css from "./Loading.module.css";

export enum LoadingAppearance {
    Small,
    Big,
    SmallTransparent,
}

export interface ILoading {
    isModal?: boolean;
    noModalLayer?: boolean;
    appearance?: LoadingAppearance;
    className?: string;
}

const getAppearanceClassName = (appearance?: LoadingAppearance): string => {
    switch (appearance) {
        case LoadingAppearance.Big:
            return css.big;
        case LoadingAppearance.SmallTransparent:
            return css.smallTransparent;
        default:
            return css.small;
    }
};

const Loading: FC<ILoading> = (props) => {
    return (
        <div
            className={clsx(
                css.loadingComponent,
                getAppearanceClassName(props.appearance),
                props.isModal && css.isModal,
                props.className,
            )}
        >
            {props.isModal && !props.noModalLayer ? <div className={css.loadingModal} /> : null}
            <svg className={css.loadingIcon}>
                <use xlinkHref="#loadingIcon" />
            </svg>
        </div>
    );
};

export { Loading };
